import React from "react";

const PatientEnrolmentBookEyeCheckHeading = () => {
  return (
    <section id="patient-enrolment-book-eye-step-zero">
      <div className="mdc-layout-grid max-width">
        <div className="mdc-layout-grid__inner">
          <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-12-tablet">
            <div id="success-signup-container">
              <i
                className="done-icon material-icons mdc-button__icon"
                aria-hidden="true"
              >
                done
              </i>
              You have successfully signed up for KeepSight.
            </div>
            <h1 id="time-to-book-title">Time to book an eye check!</h1>
            <p className="semi-bold">
              It looks like you are overdue to get your eyes checked.
            </p>
            <p>
              It is recommended people with diabetes get eye checks at least
              every two years. More frequent checks may be necessary if you have
              pre-existing diabetes related eye disease like diabetic
              retinopathy or if your eye care provider considers you to be at a
              higher risk of eye disease. If so, you should follow the advice of
              your eye care provider about the timing of your next eye check.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PatientEnrolmentBookEyeCheckHeading;
